/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { PlanStudyRightValues } from './planStudyRightModal.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'plan-study-right-modal',
    standalone: false,
})
export class PlanStudyRightModalDirective extends UpgradeComponent {
    @Output() close: EventEmitter<any>;
    @Output() dismiss: EventEmitter<any>;
    @Input() resolve: PlanStudyRightValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('planStudyRightModal', elementRef, injector);
    }
}
